import actionTypes from 'src/modules/redux/actionTypes'

export const setNewLogo = logo => ({
  type: actionTypes.SET_NEW_LOGO,
  payload: logo
})
